export default __webpack_public_path__ + "static/media/arequipa-canyon.e6cfa99e.jpg";